<template>
  <HeaderAdmin v-if="accountData.role===3"></HeaderAdmin>
  <AdminIndex v-if="accountData.role===3"></AdminIndex>
  <HeaderAdmin v-if="admin.includes(parseInt(accountData.role))"></HeaderAdmin>
  <AdminIndex v-if="admin.includes(parseInt(accountData.role))"></AdminIndex>
</template>

<script>
import HeaderAdmin from "@/components/HeaderAdmin";
import router from "@/router";
import AdminIndex from "@/components/AdminIndex";
export default {
  name: "routerAdmin",
  components: {AdminIndex, HeaderAdmin},
  data:()=>({
    admin : [3,4,5,6,7,8,9,10,11,12,13,14],
    accountData:{
      nama:'',
      email:'',
      role:''
    },
  }),
  methods:{
    getUserInformation(){
      let userdata = this.$store.getters.getUserInfo;
      if(userdata != null){
        this.accountData.nama = userdata.data.fullname;
        this.accountData.email = userdata.data.email;
        this.accountData.role = userdata.data.userRole;
        if(!this.admin.includes(parseInt(this.accountData.role))){
          router.push('/home');
        }
      }else{
        router.push('/login');
      }
    }
  },
  beforeMount() {
    this.getUserInformation();
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>